import { usePendingInvites, useAcceptInvite } from "@/hooks/useOrganization";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import { Mail, Loader2 } from "lucide-react";

export default function InviteBanner() {
  const { data: invites } = usePendingInvites();
  const acceptMutation = useAcceptInvite();

  if (!invites?.length) return null;

  const handleAccept = async (inviteId: string, orgName: string) => {
    try {
      await acceptMutation.mutateAsync(inviteId);
      toast({ title: "Welcome!", description: `You've joined ${orgName}.` });
    } catch (err: any) {
      toast({ title: "Error", description: err.message, variant: "destructive" });
    }
  };

  return (
    <>
      {invites.map((invite: any) => (
        <div key={invite.id} className="bg-accent text-accent-foreground text-center text-sm py-2 px-4 flex items-center justify-center gap-2">
          <Mail className="h-3.5 w-3.5" />
          You've been invited to join <strong>{invite.organizations?.name || "an organization"}</strong>.
          <Button
            size="sm"
            variant="secondary"
            className="ml-2 h-7"
            onClick={() => handleAccept(invite.id, invite.organizations?.name)}
            disabled={acceptMutation.isPending}
          >
            {acceptMutation.isPending ? <Loader2 className="h-3 w-3 animate-spin" /> : "Accept"}
          </Button>
        </div>
      ))}
    </>
  );
}
